import React, { Component, } from "react";
import { BrowserRouter, Route, Switch, } from "react-router-dom";
import "./styles/main.css";
import Landing from "./views/Landing/Landing";
import Results from "./views/Results/Results";
import PDF from "./views/Pdf/Pdf";

export default class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/:x.pdf" component={PDF} />
          <Route path="/:refnum" render={(props) => (
            <Results key={props.match.params.refnum} {...props} />)
          } />
          <Route exact path="/" component={Landing} />
        </ Switch>
      </ BrowserRouter>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App.js